import config from "../../app.json";
import axios from "axios";

import { Context } from "../../Reducers/Store";
import "./VideoArchiveCard.scss";
import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import MiniLogoURL from "../../Assets/Svgs/banner-placeholder.svg";
import EyeCut from "../../Assets/Images/eye-cut.png";
import AlertComponent from "../AlertComponent";
import ChurchModal from "../ChurchModal";
import moment from 'moment';

function VideoArchiveCard({
    id = null,
    eventId = null,
    eventName = null,
    converted = false,
    startDate = null,
    stopDate = null,
    convertDate = null,
    title = null,
    hide = false,
    coverGuid = null,
    seriesName = null,
    refresh = null,
    s3MP4Path = null,
    currentPage = 0
}) {
    let navigate = useNavigate();
    const [state, dispatch] = useContext(Context);
    const [confirm, setConfirm] = useState({ invisible: false });

    const hideConfirm = (invis) => {
        setConfirm({ invisible: invis });
    };


    const handleConvert = () => {
        axios.post(config.API + "/api/event/convertEvent", {
            eventId: eventId,
            instanceId: id,
        }).then((res) => {
            if (refresh)
                refresh();
        }).catch(function (error) {
            return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
        });
    }

    const handleDownload = (e) => {
        e.preventDefault();
        axios.post(config.API + "/api/event/downloadEventInstance", {
            eventId: eventId,
            instanceId: id,
        }).then((res) => {
            window.location.href = res.data;
        }).catch(function (error) {
            return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
        });
    }

    return (
        <div >
            <ChurchModal {...confirm} />
            <Row>
                <Col md="12">
                    <div className="cc-card archive-item">
                        <div className="left-content">
                            <div className="thumb" style={{ backgroundImage: `url(${coverGuid ? config.API + "/api/file/download/?guid=" + coverGuid : MiniLogoURL})` }}></div>
                            <div className="archive-info">
                                <h6>
                                    {hide && <img style={{ width: 16, height: 16, marginRight: 10 }} src={EyeCut} title="This Video is Hide for the Public" />}
                                    {title ?? eventName}
                                </h6>
                                <div className="date-time">
                                    <div>
                                        <small style={{ color: '#8E8C99' }}>Date: </small>
                                        <small style={{ color: '#5570F1' }}>{moment(startDate).format("MM/DD/YYYY")}</small>
                                    </div>
                                    <div>
                                        <small style={{ color: '#8E8C99' }}>Start Time: </small>
                                        <small style={{ color: '#5570F1' }}>{moment(startDate).format("h:mm A")}</small>
                                    </div>
                                    {seriesName && <div className="series-badge" title="This video is part of a series">{seriesName}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="archive-actions">
                            {!converted && <Button className="video-archive-convert-btn" title="Convert" onClick={(() => {
                                setConfirm({
                                    invisible: true,
                                    setInvisible: (invis) => hideConfirm(invis),
                                    title: "Convert Event",
                                    content: `You're about to start a conversion job to this event. Are you sure you want to continue?`,
                                    createItem: `Confirm`,
                                    discardItem: `Cancel & Close`,
                                    onSubmit: () => handleConvert(id),
                                    messageTitle: `Success`,
                                    message: "Event conversion was start successfully!",
                                });
                            })} >
                                Convert
                            </Button>}
                            {converted && s3MP4Path && <a className="video-archive-download-btn" title="Download" href="#" onClick={handleDownload}>
                                Download
                            </a>}
                            <Button className="video-archive-edit-btn" title="Edit" onClick={() => navigate("/videoArchive/edit/" + id, { state: { currentPage: currentPage }, replace: false })}>
                                Edit
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default VideoArchiveCard;
